import { Grid, makeStyles, Typography, Box } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { GLANCE_PARAMS, GLANCE_RATES } from "../../constants";
import { Image, Icon } from "../../../../components/base";

import NOIImg from "../../../../assets/images/building/NOI.svg";
import vacancyImg from "../../../../assets/images/building/vacancy.svg";
import AboveAvgIcon from "../../../../assets/images/icons/above-avg.svg";
import BelowAvgIcon from "../../../../assets/images/icons/below-avg.svg";
import rentalRevenueImg from "../../../../assets/images/building/rentalRevenue.svg";
import carbonReductionImg from "../../../../assets/images/building/carbonReduction.svg";
import connectedTenantImg from "../../../../assets/images/building/connectedTenant.svg";
import powerAssetRevenueImg from "../../../../assets/images/building/powerAssetRevenue.svg";
import powerTradingRevenueImg from "../../../../assets/images/building/powerTradingRevenue.svg";
import buildingProfitabilityImg from "../../../../assets/images/building/building-profitability.svg";
import { ShaDowBox } from "../../../../components/boxes";

const useStyles = makeStyles(() => ({
  rateIcon: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  img: {
    position: "relative",
    width: 85,
    height: 85,
    backgroundColor: COLORS.darks[6],
    borderRadius: "50%",
    margin: "0 auto 10px",
  },
}));

export const InfoCard = ({ param, rate, title, content, desc }) => {
  const classes = useStyles();

  const Img = {
    [GLANCE_PARAMS.rental_revenue]: rentalRevenueImg,
    [GLANCE_PARAMS.vacancy]: vacancyImg,
    [GLANCE_PARAMS.carbon_reduction]: carbonReductionImg,
    [GLANCE_PARAMS.connected_tenant]: connectedTenantImg,
    [GLANCE_PARAMS.power_trading_revenue]: powerTradingRevenueImg,
    [GLANCE_PARAMS.power_asset_revenue]: powerAssetRevenueImg,
    [GLANCE_PARAMS.noi_increase]: NOIImg,
    [GLANCE_PARAMS.building_profitability]: buildingProfitabilityImg,
  }[param];

  return (
    <ShaDowBox
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <Grid container justifyContent="center" alignItems="center" className={classes.img}>
        <Image src={Img} />
        {rate ? (
          <Icon
            root={classes.rateIcon}
            src={rate === GLANCE_RATES.bad ? BelowAvgIcon : AboveAvgIcon}
            tooltip={rate === GLANCE_RATES.bad ? "Below portfolio avg" : "Above portfolio avg"}
            hoverable
          />
        ) : null}
      </Grid>

      <Box style={{ textAlign: "center" }}>
        <Typography variant="h4">{title}</Typography>
        <Grid container alignItems="center" justifyContent="center" style={{ marginTop: 10 }}>
          <Typography variant="h3" style={{ fontSize: 21 }}>
            {content}
          </Typography>
          {desc && (
            <Typography variant="h4" style={{ marginLeft: 10 }}>
              {desc}
            </Typography>
          )}
        </Grid>
      </Box>
    </ShaDowBox>
  );
};
